import {
  destinationTypeCustomHtml,
  destinationTypeEmail,
  destinationTypeFacebookConversion,
  destinationTypeGoogleConversion,
  destinationTypeSalesforce,
  destinationTypeSlack,
  destinationTypeWebhook,
} from '~/lib/destinations';
import CustomHtml from '~/pages/destinations/forms/CustomHtml';
import Email from '~/pages/destinations/forms/Email';
import FacebookConversion from '~/pages/destinations/forms/FacebookConversion';
import GoogleConversion from '~/pages/destinations/forms/GoogleConversion';
import Salesforce from '~/pages/destinations/forms/Salesforce';
import Slack from '~/pages/destinations/forms/Slack';
import Webhook from '~/pages/destinations/forms/Webhook';

const componentForType = (type) => {
  switch (type) {
    case destinationTypeCustomHtml:
      return CustomHtml;

    case destinationTypeEmail:
      return Email;

    case destinationTypeFacebookConversion:
      return FacebookConversion;

    case destinationTypeGoogleConversion:
      return GoogleConversion;

    case destinationTypeSalesforce:
      return Salesforce;

    case destinationTypeSlack:
      return Slack;

    case destinationTypeWebhook:
      return Webhook;

    default:
      throw new Error(`Unknown destination type "${type}"`);
  }
};

export default function DestinationFormFactory(props) {
  const Component = componentForType(props.type);

  return <Component {...props} />;
}

DestinationFormFactory.propTypes = {
  type: PropTypes.string.isRequired,
  errors: PropTypes.array.isRequired,
  refetch: PropTypes.func.isRequired,
  accountConnector: PropTypes.object,
  attributes: PropTypes.array.isRequired,
  FormFooter: PropTypes.elementType,
  destination: PropTypes.object,
  destinationOptions: PropTypes.object,
  segment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    collection: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
